import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=9f5da28e"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=9f5da28e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports